// language picker
const languagePickerButton = document.getElementById("language-picker-button");
const languagePicker = document.getElementById("language-picker-list");

if (languagePickerButton && languagePicker) {
  // toggle language picker
  languagePickerButton.addEventListener("click", () => {
    // toggle the active class
    languagePickerButton.classList.toggle("active");

    // aria expanded
    const expanded =
      languagePickerButton.getAttribute("aria-expanded") === "true" || false;
    languagePickerButton.setAttribute("aria-expanded", !expanded);

    // toggle the hidden class
    languagePicker.classList.toggle("hidden");
  });
}
